import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import './CampaignDetailPage.css';

function CampaignDetailsPage() {
  const { id } = useParams(); // get campaign ID from URL
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    const fetchCampaignDetails = async () => {
      try {
        const Authtoken = localStorage.getItem("token");
        const res = await axios.get(`https://leadbankapi.gensparc.com/api/facebook/campaign/${id}`, {
          headers: { Authorization: `Bearer ${Authtoken}` }
        });
        setCampaign(res.data);
      } catch (error) {
        console.error("Error fetching campaign:", error);
      }
    };

    fetchCampaignDetails();
  }, [id]);

  if (!campaign) return <p>Loading campaign details...</p>;

  return (
    <div className="campaign-detail-container">
      <div className="campaign-detail-header">
        <h2>Campaign: {campaign.name}</h2>
      </div>

      <div className="campaign-detail-section">
        <h4>Page:</h4>
        <p>{campaign.pageName}</p>
      </div>

      <div className="campaign-detail-section">
        <h4>Form:</h4>
        <p>{campaign.formName}</p>
      </div>

      <div className="leads-list">
        <h3>Leads:</h3>
        <pre>{JSON.stringify(campaign.leads, null, 2)}</pre>
      </div>
    </div>
  );
}

export default CampaignDetailsPage;
